import * as React from 'react'
import { StyledIframe } from './LiveScores.styled'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    url: string
}

/** get any aditional parameters from the window href */
const getScoreBoardParams = () => {
    const liveScoresSplitPath = '#/'
    const currentPage = window.location.href

    if (currentPage.indexOf(liveScoresSplitPath) === -1) {
        return
    }

    const split = currentPage.split(liveScoresSplitPath)

    if (split.length !== 2) {
        return
    }

    const cricketParams = split[1]

    if (cricketParams.length > 0 && cricketParams !== undefined) {
        return cricketParams
    }

    return
}

export const LiveScores: React.FC<Props> = props => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Advertising | ConsentLevel.Analytics,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    // As of implementation, we don't have access to the query string in SSR, so we render a fragment
    // until it becomes available after re-hydrate.
    if (typeof window === 'undefined' || window.location === undefined) {
        return <React.Fragment />
    }

    const params = getScoreBoardParams() || 'crickethome?sId=0&t=m'

    return (
        <StyledIframe
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            src={`${props.url}/cwc/#/${params}`}
        />
    )
}
